const defaultCardColor = '#fff';

const mainActions = [
  {
    id: 1,
    brand: 'Child Challenge',
    title: "Check and edit my child's challenge",
    cardStyles: { cardColor: defaultCardColor, icon: 'ChildChallenge' },
    router: 'challenge-select-child?next=challenge-parent-approve',
  },
  {
    id: 2,
    brand: 'Rewards',
    title: 'Add and claim rewards',
    cardStyles: { cardColor: defaultCardColor, icon: 'Rewards' },
    router: 'rewards',
  },
  {
    id: 3,
    brand: 'Parent Goals',
    title: 'Rate and edit my parent goals',
    cardStyles: { cardColor: defaultCardColor, icon: 'GoalsParents' },
    router: '/parent-goals',
  },
  {
    id: 4,
    brand: 'Skill Visuals and Videos',
    title: 'Review parenting strategies',
    cardStyles: { cardColor: defaultCardColor, icon: 'SkillVisual' },
    router: '/plan-select-skill?type=learn',
  },
  {
    id: 5,
    brand: 'Parenting Solutions',
    title: 'Problem solving for child behavior and parenting challenges',
    cardStyles: { cardColor: defaultCardColor, icon: 'ProblemSolving' },
    router: '/help-main',
  },
];

export { mainActions };
